<i18n lang="yaml">
en:
  title: "What's next?"
  registration: 'Registration in&nbsp;the control panel'
  registrationText: 'Register an&nbsp;account in&nbsp;the Selectel control panel, top up&nbsp;your balance in&nbsp;a&nbsp;convenient way and take advantage of&nbsp;Selectel dedicated servers.'
  registrationButton: 'Go to panel'
  consultation: 'Consultation before ordering'
  consultationText: 'You can always get a&nbsp;free consultation by&nbsp;calling&nbsp;us on&nbsp;{0}, sending a&nbsp;message to&nbsp;{2} or&nbsp;an&nbsp;e-mail to&nbsp;{1}&nbsp;&mdash; tell&nbsp;us about your project and we&nbsp;will offer you the best solution for your budget and requirements.'
  consultationButton: 'Chat with a&nbsp;consultant'
ru:
  title: 'Что дальше?'
  registration: 'Регистрация в&nbsp;панели управления'
  registrationText: 'Зарегистрируйте аккаунт в&nbsp;панели управления Selectel, пополните баланс удобным способом и&nbsp;воспользуйтесь преимуществами выделенных серверов Selectel.'
  registrationButton: 'Создать аккаунт'
  consultation: 'Консультация перед заказом'
  consultationText: 'По&nbsp;телефону {0}, почте {1} или в&nbsp;{2}&nbsp;&mdash; изучим задачу и&nbsp;подберем лучшее решение под ваш бюджет и&nbsp;требования.'
  consultationButton: 'Чат с консультантом'
</i18n>

<template>
  <s-section
    id="consultation"
    is-sub-section
    :title="$t('title')"
  >
    <div class="row">
      <div class="col-xl-11">
        <div class="consultation__items">
          <div class="consultation__item">
            <h4
              class="consultation__title"
              v-html="$t('registration')"
            ></h4>
            <p
              class="consultation__description"
              v-html="registrationText || $t('registrationText')"
            ></p>
            <a
              :href="link"
              class="btn btn--dark btn--responsive"
              v-html="$t('registrationButton')"
            ></a>
          </div>
          <div class="consultation__item">
            <h4
              class="consultation__title"
              v-html="$t('consultation')"
            ></h4>
            <p
              class="consultation__description"
              v-html="consultationText || $t('consultationText', [`
                <a
                  href='tel:+78005550675'
                  data-gtmid='gtm-selectel-call-click'
                  >8&nbsp;800&nbsp;555 06&nbsp;75</a>`, `
                <a
                  href='mailto:sales@selectel.ru'
                  data-gtmid='gtm-selectel-mailto-click'
                  >sales@selectel.ru</a>`, `
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://t.me/SelectelTgbot'
                  data-gtmid='gtm-selectel-telegram-click'
                  >Telegram</a>`
              ])"
            ></p>
            <button
              class="btn btn--outline btn--responsive"
              @click="openJivoChat"
              v-html="$t('consultationButton')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </s-section>
</template>

<script>
import JivoUtils from '~/mixins/jivo-utils'

export default {
  name: 'Consultation',
  mixins: [
    JivoUtils
  ],
  props: {
    registrationText: {
      type: String,
      default: ''
    },
    consultationText: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.consultation__items {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 1fr;
    grid-gap: 40px;
  }
}

.consultation__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .btn {
    margin-top: auto;
  }
}

.consultation__title {
  margin-bottom: 28px;

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 16px;
  }
}

.consultation__description {
  margin-bottom: 32px;
  max-width: 460px;

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 24px;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;
  }
}
</style>